import { Spinner } from "react-bootstrap";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

function PageLoader({url}) {
  const navigate = useNavigate();


  useEffect(() => {
    const timer = setTimeout(() => {
      window.location.href = url;
    }, 2000);

    return () => clearTimeout(timer);
  }, []);
  return (
    <>
      <div className="d-flex flex-column justify-content-center align-items-center vh-100">
        <Spinner animation="border" variant="success" /> Loading to Department
        for Behavioral Health page.
      </div>
    </>
  );
}

export default PageLoader;
